import { CalendarIcon } from "@heroicons/react/24/outline";
import { defaultLinkStyle } from "components/ui/link";
import React from "react";
import { Link } from "react-router-dom";
import { EntityActivitySummary } from "./details/entity-activity-summary";
import { EntityActivityEntryProps } from "./types";

const methodLabel = (method: string | undefined): string | null => {
    switch (method) {
        case "email":
            return "by email";
        case "manual":
            return "marked manually";
        default:
            return null;
    }
};

export const EntityActivityEventInvited: React.FC<EntityActivityEntryProps> = props => {
    const { activity } = props;
    const event = activity.activity.metadata?.events?.find(
        e => e.type === "EventInvited",
    );
    const eventTitle = event?.eventInvited?.eventTitle;
    const eventId = event?.eventInvited?.eventId;
    const method = methodLabel(event?.eventInvited?.method);

    return (
        <div className="relative flex items-start space-x-3">
            <div className="relative px-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                    <CalendarIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
                </div>
            </div>
            <div className="min-w-0 flex-1 group pt-1">
                <EntityActivitySummary {...props}>
                    Invited
                    {eventTitle ? (
                        <>
                            {" "}
                            to{" "}
                            {eventId ? (
                                <Link
                                    className={defaultLinkStyle}
                                    to={`/events/${eventId}`}>
                                    {eventTitle}
                                </Link>
                            ) : (
                                <strong>{eventTitle}</strong>
                            )}
                        </>
                    ) : null}
                    {method ? ` (${method})` : null}.
                </EntityActivitySummary>
            </div>
        </div>
    );
};
